var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFusdtz(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "120px",
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\uA730USDtz") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-37.4999631%",
    y1: "50.0001949%",
    x2: "112.499935%",
    y2: "50.0001949%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F61FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F61FF",
    offset: "18.4658%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F329F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-37.4999631%",
    y1: "50.0001949%",
    x2: "112.499935%",
    y2: "50.0001949%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F61FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F61FF",
    offset: "18.4658%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F329F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "59.9999646 13.507835 100.265059 36.7548123 100.265059 83.2487316 59.9999646 106.495567 19.7349407 83.2487316 19.7349407 36.7548123"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uA730USDtz",
    stroke: "none",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.385692,31.4871635 L59.9998872,2.97433393 L10.6143084,31.487167 L10.6143084,88.5129442 L59.9998872,117.025669 L109.385692,88.5129476 L109.385692,31.4871635 Z M59.9983389,8.92022235 L104.231645,34.4600072 L104.231645,85.5360352 L59.9983389,111.07582 L15.7650324,85.5360352 L15.7650324,34.4600072 L59.9983389,8.92022235 Z",
    id: "Path",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.961531,27.1132505 L64.9998858,2.88674493 C61.9058739,1.10042088 58.0938966,1.10042456 54.9998881,2.88675458 L13.0384522,27.1132473 C9.94444553,28.8995763 8.03845943,32.2008442 8.03845943,35.7734972 L8.03845943,84.2266046 C8.03845943,87.7992634 9.94445167,91.1005357 13.0384663,92.8868626 L54.9999028,117.113265 C58.0939038,118.899584 61.9058668,118.899588 64.9998714,117.113275 L106.961516,92.8868662 C110.055541,91.100542 111.961541,87.7992641 111.961541,84.2265981 L111.961541,35.77351 C111.961541,32.2008502 110.055547,28.899577 106.961531,27.1132505 Z M64.9998917,8.83541218 L101.809832,30.0875833 C104.903849,31.8739097 106.809843,35.1751831 106.809843,38.7478433 L106.809843,81.2522541 C106.809843,84.8249201 104.903843,88.1261981 101.809818,89.9125223 L64.9998774,111.164613 C61.9058728,112.950925 58.0939098,112.950922 54.9999088,111.164603 L18.1901643,89.9125257 C15.0961496,88.1261988 13.1901574,84.8249264 13.1901574,81.2522677 L13.1901574,38.7478297 C13.1901574,35.1751768 15.0961434,31.873909 18.19015,30.0875799 L54.9998946,8.83542233 C58.0939028,7.04909235 61.9058798,7.04908848 64.9998917,8.83541218 Z",
    id: "Path",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,109.277107 C87.0294581,109.277107 108.941042,87.3655225 108.941042,60.3360644 C108.941042,33.3067834 87.0294581,11.3951639 60,11.3951639 C32.9705773,11.3951639 11.0589578,33.3067834 11.0589578,60.3360644 C11.0589578,87.3655225 32.9705773,109.277107 60,109.277107 Z",
    id: "Path",
    fill: "#F2F2F2",
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6613448,71.9750861 C86.2083046,84.6137008 74.1620756,93.6717191 60.0000798,93.6717191 C45.8380612,93.6717191 33.7917353,84.6136827 29.3386552,71.9750747 L34.8985034,71.9754585 C39.0857267,81.6910986 48.7485991,88.4924134 60.0000798,88.4924134 C71.2515319,88.4924134 80.91432,81.69112 85.1015023,71.9754748 Z M60.0000798,28.6717191 C73.8811496,28.6717191 85.7295706,37.3739876 90.387432,49.6205804 L84.7659509,49.62064 C80.4137973,40.3053413 70.9607351,33.8510248 60.0000798,33.8510248 C49.0393966,33.8510248 39.5862537,40.3053616 35.234058,49.6206567 L29.6125704,49.6205922 C34.2704731,37.374005 46.1189877,28.6717191 60.0000798,28.6717191 Z",
    id: "Combined-Shape",
    fill: "#505050",
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1005434,49.9946371 L28.8994566,49.9946371 C27.5067613,49.9946371 26.377797,51.4042922 26.377797,53.143091 L26.377797,69.2003473 C26.377797,70.9391461 27.5067613,72.3488012 28.8994566,72.3488012 L91.1005434,72.3488012 C92.4931821,72.3488012 93.622203,70.9391461 93.622203,69.2003473 L93.622203,53.143091 C93.622203,51.4042922 92.4931821,49.9946371 91.1005434,49.9946371 Z",
    id: "Path",
    fill: "#F2F2F2",
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7106574,39.0366657 L63.0645753,39.3905836 L63.0619634,44.8882774 L63.4611695,44.9488618 C67.8604288,45.6746594 71.0125937,47.682982 71.3168121,50.7532604 L71.340946,51.2468341 L71.340946,54.9597871 L70.9870281,55.313705 L65.8131019,55.313705 L65.459184,54.9597871 L65.459184,52.9513029 C65.459184,51.3635132 63.2968894,50.1397789 60.3956802,50.1397789 C57.3580933,50.1397789 55.2713026,51.4203659 55.2713026,53.4991678 C55.2713026,55.2806446 56.3607457,56.323325 59.4480088,57.5816962 L60.7011545,58.0655601 C61.1512685,58.231461 61.6343725,58.4025964 62.1522409,58.5808304 L63.7415518,59.1268435 C69.7800608,61.2979108 72.5584237,63.6639704 72.5584237,68.2295858 C72.5584237,73.2313757 68.749008,76.6223264 62.7595312,77.4574362 L63.0615763,77.4116657 L63.0645753,82.9401844 L62.7106574,83.2941023 L57.2967749,83.2941023 L56.942857,82.9401844 L56.9427225,77.4345699 L56.5200656,77.3736937 C51.4687231,76.5327173 47.7889234,73.9995372 47.4648328,70.4482364 L47.4415763,69.9340545 L47.4415763,66.6472188 L47.7954942,66.2933008 L52.9694204,66.2933008 L53.3233383,66.6472188 L53.3233383,68.655703 C53.3233383,70.752442 56.2582868,72.1364858 60.0304369,72.1364858 C63.5301255,72.1364858 65.8853012,70.7266221 65.8853012,68.5339552 C65.8853012,66.4012735 64.448385,65.3975109 59.9513713,63.7989401 L58.4441634,63.2649069 L57.4221882,62.8780247 C51.3799036,60.5491335 48.5981801,58.1508203 48.5981801,53.5596878 C48.5981801,48.8899548 52.0373166,45.878377 57.2348244,44.9543288 L56.9427225,45.0086095 L56.942857,39.3905836 L57.2967749,39.0366657 L62.7106574,39.0366657 Z",
    id: "Path",
    fill: "#505050",
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFusdtz);
export default __webpack_public_path__ + "static/media/fusdtz.634c976cc276a37482692d567c5f8d2b.svg";
export { ForwardRef as ReactComponent };